import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clienteService, garantiaService, prestamoService } from '../services/api';
import '../styles/Garantias.css';

const Garantias = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const vistaInicial = queryParams.get('vista') || 'lista';

  const [vista, setVista] = useState(vistaInicial); // lista, asistente, nueva, editar, vincular, eliminar, estadisticas, detalles
  const [garantias, setGarantias] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [prestamos, setPrestamos] = useState([]);
  const [clienteFiltro, setClienteFiltro] = useState('');
  const [cargando, setCargando] = useState(false);
  const [garantiaSeleccionada, setGarantiaSeleccionada] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [estadisticas, setEstadisticas] = useState(null);

  // Estados para vincular
  const [clienteVincular, setClienteVincular] = useState('');
  const [prestamoVincular, setPrestamoVincular] = useState('');
  const [garantiaVincular, setGarantiaVincular] = useState('');

  // Estados para el formulario
  const [formData, setFormData] = useState({
    cliente_id: '',
    categoria: '',
    producto_tipo: '',
    marca: '',
    modelo: '',
    color: '',
    estado: '',
    descripcion: '',
    numero: '',
    valor_estimado: ''
  });

  // Opciones para los select
  const categorias = {
    'Electrónica/Tecnología': ['Laptop', 'Tablet', 'Celular', 'Televisor', 'Consola', 'Cámara', 'Impresora', 'Otros'],
    'Vehículos': ['Motor', 'Carro', 'Bicicleta', 'Otros'],
    'Electrodomésticos': ['Refrigeradora', 'Lavadora', 'Secadora', 'Estufa', 'Microondas', 'Aire Acondicionado', 'Ventilador', 'Otros'],
    'Muebles': ['Sala', 'Comedor', 'Dormitorio', 'Oficina', 'Otros'],
    'Joyería': ['Anillo', 'Cadena', 'Pulsera', 'Reloj', 'Aretes', 'Otros'],
    'Inmuebles': ['Casa', 'Apartamento', 'Terreno', 'Local Comercial', 'Otros'],
    'Herramientas': ['Eléctricas', 'Manuales', 'Jardinería', 'Construcción', 'Otros'],
    'Instrumentos Musicales': ['Guitarra', 'Piano', 'Batería', 'Otros'],
    'Deportes': ['Bicicleta', 'Equipo de Gym', 'Otros'],
    'Otros': ['Otros']
  };

  const estados = ['Nueva', 'Excelente', 'Buena', 'Regular', 'Mala'];

  useEffect(() => {
    console.log('=== GARANTIAS: Componente montado, cargando datos ===');
    cargarDatos();
  }, [clienteFiltro]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const vistaParam = queryParams.get('vista');
    if (vistaParam) {
      setVista(vistaParam);
      if (vistaParam === 'estadisticas') {
        cargarEstadisticas();
      }
    }
  }, [location.search]);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const params = clienteFiltro ? { cliente_id: clienteFiltro } : {};
      const [responseGarantias, responseClientes, responsePrestamos] = await Promise.all([
        garantiaService.getAll(params),
        clienteService.getAll({ per_page: 1000 }), // Cargar todos los clientes
        prestamoService.getAll()
      ]);

      console.log('Response Garantias:', responseGarantias);
      console.log('Response Clientes:', responseClientes);
      console.log('Response Prestamos:', responsePrestamos);

      setGarantias(responseGarantias.data.garantias || []);
      setClientes(responseClientes.data.clientes || []);
      setPrestamos(responsePrestamos.data.prestamos || []);

      console.log('Clientes cargados:', responseClientes.data.clientes?.length || 0);
    } catch (error) {
      console.error('Error al cargar datos:', error);
      console.error('Error completo:', error.response || error);
      alert('Error al cargar datos: ' + (error.response?.data?.error || error.message));
    } finally {
      setCargando(false);
    }
  };

  const cargarEstadisticas = async () => {
    try {
      const response = await garantiaService.getStats();
      setEstadisticas(response.data);
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
      alert('Error al cargar estadísticas');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCategoriaChange = (e) => {
    setFormData(prev => ({
      ...prev,
      categoria: e.target.value,
      producto_tipo: '' // Resetear producto al cambiar categoría
    }));
  };

  const resetForm = () => {
    setFormData({
      cliente_id: '',
      categoria: '',
      producto_tipo: '',
      marca: '',
      modelo: '',
      color: '',
      estado: '',
      descripcion: '',
      numero: '',
      valor_estimado: ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    try {
      if (vista === 'editar') {
        await garantiaService.update(garantiaSeleccionada.id, formData);
        alert('Garantía actualizada exitosamente');
      } else {
        await garantiaService.create(formData);
        alert('Garantía creada exitosamente');
      }

      resetForm();
      setVista('lista');
      cargarDatos();
    } catch (error) {
      console.error('Error:', error);
      alert(error.response?.data?.error || 'Error al guardar la garantía');
    } finally {
      setCargando(false);
    }
  };

  const handleEditar = (garantia) => {
    setGarantiaSeleccionada(garantia);
    setFormData({
      cliente_id: garantia.cliente_id,
      categoria: garantia.categoria || '',
      producto_tipo: garantia.producto_tipo || '',
      marca: garantia.marca || '',
      modelo: garantia.modelo || '',
      color: garantia.color || '',
      estado: garantia.estado || '',
      descripcion: garantia.descripcion || '',
      numero: garantia.numero || '',
      valor_estimado: garantia.valor_estimado || ''
    });
    setVista('editar');
  };

    const handleEliminar = async () => {
    try {
      await garantiaService.delete(garantiaSeleccionada.id);
      alert('Garantía eliminada exitosamente');
      setVista('lista');
      setGarantiaSeleccionada(null);
      cargarDatos();
    } catch (error) {
      console.error('Error al eliminar garantía:', error);
      const mensaje = error.response?.data?.error || 'Error al eliminar la garantía';
      alert(mensaje);
    }
  };

  const abrirVincular = (garantia) => {
    setGarantiaVincular(garantia);
    setClienteVincular(garantia.cliente_id);
    setVista('vincular');
  };

  const handleVincular = async (e) => {
    e.preventDefault();

    if (!prestamoVincular) {
      alert('Debe seleccionar un préstamo');
      return;
    }

    try {
      await garantiaService.vincularPrestamo(clienteVincular, {
        prestamo_id: prestamoVincular,
        garantia_id: garantiaVincular.id
      });
      alert('Garantía vinculada exitosamente');
      setVista('lista');
      setGarantiaVincular(null);
      setClienteVincular('');
      setPrestamoVincular('');
      cargarDatos();
    } catch (error) {
      console.error('Error al vincular garantía:', error);
      alert(error.response?.data?.error || 'Error al vincular la garantía');
    }
  };

  const getClienteNombre = (clienteId) => {
    const cliente = clientes.find(c => c.id === clienteId);
    return cliente ? `${cliente.nombres} ${cliente.apellidos}` : 'Desconocido';
  };

  const garantiasFiltradas = garantias.filter(g => {
    if (!busqueda) return true;
    const searchLower = busqueda.toLowerCase();
    const clienteNombre = getClienteNombre(g.cliente_id).toLowerCase();
    return clienteNombre.includes(searchLower) ||
           g.tipo?.toLowerCase().includes(searchLower) ||
           g.categoria?.toLowerCase().includes(searchLower) ||
           g.marca?.toLowerCase().includes(searchLower) ||
           g.modelo?.toLowerCase().includes(searchLower);
  });

  // Vista Lista
  if (vista === 'lista') {
    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>📋 Gestión de Garantías</h1>
          <div className="header-actions">
            <button onClick={() => { setVista('estadisticas'); cargarEstadisticas(); }} className="btn-secondary">
              📊 Estadísticas
            </button>
            <button onClick={() => setVista('asistente')} className="btn-primary">
              ➕ Nueva Garantía
            </button>
          </div>
        </div>

        <div className="filtros-container">
          <div className="filtro-grupo">
            <label>Filtrar por Cliente:</label>
            <select
              value={clienteFiltro}
              onChange={(e) => setClienteFiltro(e.target.value)}
              className="input-select"
            >
              <option value="">Todos los clientes</option>
              {clientes.map(cliente => (
                <option key={cliente.id} value={cliente.id}>
                  {cliente.nombres} {cliente.apellidos} - {cliente.cedula}
                </option>
              ))}
            </select>
          </div>

          <div className="filtro-grupo">
            <label>Buscar:</label>
            <input
              type="text"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              placeholder="Buscar por cliente, tipo, marca..."
              className="input-text"
            />
          </div>
        </div>

        {cargando && <div className="loading">Cargando garantías...</div>}

        {!cargando && garantiasFiltradas.length > 0 && (
          <div className="tabla-container">
            <table className="tabla-garantias">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Cliente</th>
                  <th>Categoría</th>
                  <th>Producto</th>
                  <th>Marca/Modelo</th>
                  <th>Estado</th>
                  <th>Valor Estimado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {garantiasFiltradas.map(garantia => (
                  <tr key={garantia.id}>
                    <td>{garantia.numero || garantia.id}</td>
                    <td><strong>{getClienteNombre(garantia.cliente_id)}</strong></td>
                    <td>{garantia.categoria || 'N/A'}</td>
                    <td>{garantia.producto_tipo || 'N/A'}</td>
                    <td>
                      {garantia.marca && garantia.modelo
                        ? `${garantia.marca} ${garantia.modelo}`
                        : garantia.marca || garantia.modelo || 'N/A'}
                    </td>
                    <td>
                      <span className={`badge badge-${garantia.estado?.toLowerCase() || 'default'}`}>
                        {garantia.estado || 'N/A'}
                      </span>
                    </td>
                    <td className="valor">${garantia.valor_estimado?.toFixed(2) || '0.00'}</td>
                    <td className="acciones">
                      <button
                        onClick={() => {
                          setGarantiaSeleccionada(garantia);
                          setVista('detalles');
                        }}
                        className="btn-sm btn-detalles"
                        title="Ver Detalles"
                      >
                        👁️
                      </button>
                      <button
                        onClick={() => handleEditar(garantia)}
                        className="btn-sm btn-editar"
                        title="Editar"
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => {
                          setGarantiaSeleccionada(garantia);
                          setVista('eliminar');
                        }}
                        className="btn-sm btn-eliminar"
                        title="Eliminar"
                      >
                        🗑️
                      </button>
                      <button
                        onClick={() => abrirVincular(garantia)}
                        className="btn-sm btn-vincular"
                        title="Vincular a Préstamo"
                      >
                        🔗
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!cargando && garantiasFiltradas.length === 0 && (
          <div className="sin-datos">
            <p>No hay garantías registradas</p>
            <button onClick={() => setVista('asistente')} className="btn-primary">
              Crear primera garantía
            </button>
          </div>
        )}
      </div>
    );
  }

  // Vista Asistente/Nueva/Editar
  if (vista === 'asistente' || vista === 'nueva' || vista === 'editar') {
    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>{vista === 'editar' ? '✏️ Editar Garantía' : '➕ Nueva Garantía'}</h1>
          <button onClick={() => { setVista('lista'); resetForm(); }} className="btn-secondary">
            ← Volver
          </button>
        </div>

        <form onSubmit={handleSubmit} className="formulario-garantia">
          <div className="form-section">
            <h3>Información del Cliente</h3>
            <div className="form-group">
              <label>Cliente *</label>
              <select
                name="cliente_id"
                value={formData.cliente_id}
                onChange={handleInputChange}
                className="input-select"
                required
                disabled={vista === 'editar'}
              >
                <option value="">Seleccione un cliente</option>
                {clientes.map(cliente => (
                  <option key={cliente.id} value={cliente.id}>
                    {cliente.nombres} {cliente.apellidos} - {cliente.cedula}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-section">
            <h3>Detalles de la Garantía</h3>

            <div className="form-row">
              <div className="form-group">
                <label>Número de Garantía</label>
                <input
                  type="number"
                  name="numero"
                  value={formData.numero}
                  onChange={handleInputChange}
                  className="input-text"
                  placeholder="Ej: 1, 2, 3..."
                />
              </div>

              <div className="form-group">
                <label>Valor Estimado *</label>
                <input
                  type="number"
                  name="valor_estimado"
                  value={formData.valor_estimado}
                  onChange={handleInputChange}
                  className="input-text"
                  step="0.01"
                  required
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Categoría *</label>
                <select
                  name="categoria"
                  value={formData.categoria}
                  onChange={handleCategoriaChange}
                  className="input-select"
                  required
                >
                  <option value="">Seleccione categoría</option>
                  {Object.keys(categorias).map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Producto/Tipo *</label>
                <select
                  name="producto_tipo"
                  value={formData.producto_tipo}
                  onChange={handleInputChange}
                  className="input-select"
                  required
                  disabled={!formData.categoria}
                >
                  <option value="">Seleccione producto</option>
                  {formData.categoria && categorias[formData.categoria]?.map(prod => (
                    <option key={prod} value={prod}>{prod}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Marca</label>
                <input
                  type="text"
                  name="marca"
                  value={formData.marca}
                  onChange={handleInputChange}
                  className="input-text"
                  placeholder="Ej: Samsung, Toyota..."
                />
              </div>

              <div className="form-group">
                <label>Modelo</label>
                <input
                  type="text"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleInputChange}
                  className="input-text"
                  placeholder="Ej: Galaxy S21, Corolla..."
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Color</label>
                <input
                  type="text"
                  name="color"
                  value={formData.color}
                  onChange={handleInputChange}
                  className="input-text"
                  placeholder="Ej: Negro, Blanco, Rojo..."
                />
              </div>

              <div className="form-group">
                <label>Estado *</label>
                <select
                  name="estado"
                  value={formData.estado}
                  onChange={handleInputChange}
                  className="input-select"
                  required
                >
                  <option value="">Seleccione estado</option>
                  {estados.map(est => (
                    <option key={est} value={est}>{est}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Descripción</label>
              <textarea
                name="descripcion"
                value={formData.descripcion}
                onChange={handleInputChange}
                className="input-textarea"
                rows="4"
                placeholder="Descripción adicional de la garantía..."
              ></textarea>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={() => { setVista('lista'); resetForm(); }} className="btn-secondary">
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={cargando}>
              {cargando ? 'Guardando...' : vista === 'editar' ? 'Actualizar Garantía' : 'Guardar Garantía'}
            </button>
          </div>
        </form>
      </div>
    );
  }

  // Vista Eliminar
  if (vista === 'eliminar' && garantiaSeleccionada) {
    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>🗑️ Eliminar Garantía</h1>
          <button onClick={() => { setVista('lista'); setGarantiaSeleccionada(null); }} className="btn-secondary">
            ← Volver
          </button>
        </div>

        <div className="confirmacion-eliminar">
          <h3>¿Estás seguro de eliminar esta garantía?</h3>
          <div className="detalle-garantia">
            <p><strong>Cliente:</strong> {getClienteNombre(garantiaSeleccionada.cliente_id)}</p>
            <p><strong>Categoría:</strong> {garantiaSeleccionada.categoria}</p>
            <p><strong>Producto:</strong> {garantiaSeleccionada.producto_tipo}</p>
            <p><strong>Marca/Modelo:</strong> {garantiaSeleccionada.marca} {garantiaSeleccionada.modelo}</p>
            <p><strong>Valor:</strong> ${garantiaSeleccionada.valor_estimado?.toFixed(2)}</p>
          </div>
          <div className="form-actions">
            <button onClick={() => { setVista('lista'); setGarantiaSeleccionada(null); }} className="btn-secondary">
              Cancelar
            </button>
            <button onClick={handleEliminar} className="btn-danger" disabled={cargando}>
              {cargando ? 'Eliminando...' : 'Confirmar Eliminación'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Vista Eliminar - Selección de garantía
  if (vista === 'eliminar' && !garantiaSeleccionada) {
    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>🗑️ Eliminar Garantía</h1>
          <button onClick={() => setVista('lista')} className="btn-secondary">
            ← Volver
          </button>
        </div>

        <div className="busqueda-filtros">
          <input
            type="text"
            placeholder="Buscar garantía por cliente, categoría, marca..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="input-busqueda"
          />
        </div>

        {cargando && <div className="loading">Cargando garantías...</div>}

        {!cargando && garantiasFiltradas.length === 0 && (
          <div className="sin-datos">
            <p>No hay garantías para eliminar</p>
          </div>
        )}

        {!cargando && garantiasFiltradas.length > 0 && (
          <div className="tabla-container">
            <table className="tabla-garantias">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Cliente</th>
                  <th>Categoría</th>
                  <th>Producto</th>
                  <th>Marca/Modelo</th>
                  <th>Estado</th>
                  <th>Valor Estimado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {garantiasFiltradas.map((garantia, index) => (
                  <tr key={garantia.id}>
                    <td>{index + 1}</td>
                    <td>{getClienteNombre(garantia.cliente_id)}</td>
                    <td>{garantia.categoria || '-'}</td>
                    <td>{garantia.producto_tipo || garantia.tipo || '-'}</td>
                    <td>{garantia.marca} {garantia.modelo}</td>
                    <td>
                      <span className={`badge estado-${garantia.estado?.toLowerCase()}`}>
                        {garantia.estado || 'N/A'}
                      </span>
                    </td>
                    <td className="valor">${garantia.valor_estimado?.toFixed(2) || '0.00'}</td>
                    <td>
                      <button
                        onClick={() => setGarantiaSeleccionada(garantia)}
                        className="btn-danger-small"
                      >
                        🗑️ Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  // Vista Vincular
  if (vista === 'vincular' && garantiaVincular) {
    const prestamosCliente = prestamos.filter(p =>
      p.cliente_id === clienteVincular && (p.estado === 'activo' || p.estado === 'Activo')
    );

    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>🔗 Vincular Garantía a Préstamo</h1>
          <button onClick={() => { setVista('lista'); setGarantiaVincular(null); }} className="btn-secondary">
            ← Volver
          </button>
        </div>

        <div className="detalle-garantia">
          <h3>📦 Garantía Seleccionada</h3>
          <p><strong>Cliente:</strong> {getClienteNombre(garantiaVincular.cliente_id)}</p>
          <p><strong>Producto:</strong> {garantiaVincular.categoria} - {garantiaVincular.producto_tipo}</p>
          <p><strong>Marca/Modelo:</strong> {garantiaVincular.marca} {garantiaVincular.modelo}</p>
          <p><strong>Valor:</strong> ${garantiaVincular.valor_estimado?.toFixed(2)}</p>
        </div>

        <form onSubmit={handleVincular} className="formulario-garantia">
          <div className="form-section">
            <h3>Seleccionar Préstamo Activo</h3>

            {prestamosCliente.length === 0 ? (
              <div className="alert alert-info">
                ℹ️ Este cliente no tiene préstamos activos disponibles para vincular.
              </div>
            ) : (
              <div className="form-group">
                <label>Préstamo *</label>
                <select
                  value={prestamoVincular}
                  onChange={(e) => setPrestamoVincular(e.target.value)}
                  className="input-select"
                  required
                >
                  <option value="">Seleccione un préstamo</option>
                  {prestamosCliente.map(prestamo => (
                    <option key={prestamo.id} value={prestamo.id}>
                      Préstamo #{prestamo.id} - ${Number(prestamo.monto_prestado || 0).toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - {prestamo.fecha_inicio}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <div className="form-actions">
            <button type="button" onClick={() => { setVista('lista'); setGarantiaVincular(null); }} className="btn-secondary">
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={cargando || prestamosCliente.length === 0}>
              {cargando ? 'Vinculando...' : 'Vincular Garantía'}
            </button>
          </div>
        </form>
      </div>
    );
  }

  // Vista Estadísticas
  if (vista === 'estadisticas') {
    const totalGarantias = garantias.length;
    const valorTotal = garantias.reduce((sum, g) => sum + (parseFloat(g.valor_estimado) || 0), 0);
    const garantiasVinculadas = garantias.filter(g => g.prestamo_id).length;
    const garantiasDisponibles = totalGarantias - garantiasVinculadas;

    // Estadísticas por categoría
    const porCategoria = {};
    garantias.forEach(g => {
      const cat = g.categoria || 'Sin categoría';
      if (!porCategoria[cat]) {
        porCategoria[cat] = { cantidad: 0, valor: 0 };
      }
      porCategoria[cat].cantidad++;
      porCategoria[cat].valor += parseFloat(g.valor_estimado) || 0;
    });

    // Estadísticas por estado
    const porEstado = {};
    garantias.forEach(g => {
      const est = g.estado || 'Sin estado';
      if (!porEstado[est]) {
        porEstado[est] = 0;
      }
      porEstado[est]++;
    });

    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>📊 Estadísticas de Garantías</h1>
          <button onClick={() => setVista('lista')} className="btn-secondary">
            ← Volver
          </button>
        </div>

        <div className="estadisticas-grid">
          {/* Tarjetas de resumen */}
          <div className="stat-card stat-total">
            <div className="stat-icon">📦</div>
            <div className="stat-content">
              <h3>Total Garantías</h3>
              <p className="stat-number">{totalGarantias}</p>
            </div>
          </div>

          <div className="stat-card stat-valor">
            <div className="stat-icon">💰</div>
            <div className="stat-content">
              <h3>Valor Total Estimado</h3>
              <p className="stat-number">${valorTotal.toFixed(2)}</p>
            </div>
          </div>

          <div className="stat-card stat-vinculadas">
            <div className="stat-icon">🔗</div>
            <div className="stat-content">
              <h3>Garantías Vinculadas</h3>
              <p className="stat-number">{garantiasVinculadas}</p>
              <p className="stat-subtitle">{totalGarantias > 0 ? ((garantiasVinculadas / totalGarantias) * 100).toFixed(1) : 0}% del total</p>
            </div>
          </div>

          <div className="stat-card stat-disponibles">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <h3>Garantías Disponibles</h3>
              <p className="stat-number">{garantiasDisponibles}</p>
              <p className="stat-subtitle">{totalGarantias > 0 ? ((garantiasDisponibles / totalGarantias) * 100).toFixed(1) : 0}% del total</p>
            </div>
          </div>
        </div>

        {/* Distribución por categoría */}
        <div className="estadisticas-section">
          <h2>📂 Distribución por Categoría</h2>
          <div className="tabla-container">
            <table className="tabla-garantias">
              <thead>
                <tr>
                  <th>Categoría</th>
                  <th>Cantidad</th>
                  <th>Valor Total</th>
                  <th>Valor Promedio</th>
                  <th>Porcentaje</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(porCategoria)
                  .sort((a, b) => b[1].cantidad - a[1].cantidad)
                  .map(([categoria, datos]) => (
                    <tr key={categoria}>
                      <td><strong>{categoria}</strong></td>
                      <td>{datos.cantidad}</td>
                      <td className="valor">${datos.valor.toFixed(2)}</td>
                      <td className="valor">${(datos.valor / datos.cantidad).toFixed(2)}</td>
                      <td>
                        <div className="progress-bar">
                          <div
                            className="progress-fill"
                            style={{ width: `${(datos.cantidad / totalGarantias) * 100}%` }}
                          ></div>
                          <span className="progress-text">{((datos.cantidad / totalGarantias) * 100).toFixed(1)}%</span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Distribución por estado */}
        <div className="estadisticas-section">
          <h2>🔍 Distribución por Estado</h2>
          <div className="estados-grid">
            {Object.entries(porEstado)
              .sort((a, b) => b[1] - a[1])
              .map(([estado, cantidad]) => (
                <div key={estado} className="estado-card">
                  <span className={`badge badge-${estado.toLowerCase()}`}>{estado}</span>
                  <p className="estado-cantidad">{cantidad}</p>
                  <p className="estado-porcentaje">{((cantidad / totalGarantias) * 100).toFixed(1)}%</p>
                </div>
              ))}
          </div>
        </div>

        {/* Top 5 garantías por valor */}
        <div className="estadisticas-section">
          <h2>🏆 Top 5 Garantías por Valor</h2>
          <div className="tabla-container">
            <table className="tabla-garantias">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Categoría</th>
                  <th>Producto</th>
                  <th>Marca/Modelo</th>
                  <th>Valor Estimado</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {garantias
                  .sort((a, b) => (b.valor_estimado || 0) - (a.valor_estimado || 0))
                  .slice(0, 5)
                  .map(garantia => (
                    <tr key={garantia.id}>
                      <td><strong>{getClienteNombre(garantia.cliente_id)}</strong></td>
                      <td>{garantia.categoria}</td>
                      <td>{garantia.producto_tipo}</td>
                      <td>{garantia.marca} {garantia.modelo}</td>
                      <td className="valor"><strong>${garantia.valor_estimado?.toFixed(2)}</strong></td>
                      <td>
                        <span className={`badge badge-${garantia.estado?.toLowerCase()}`}>
                          {garantia.estado}
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  // Vista Detalles
  if (vista === 'detalles' && garantiaSeleccionada) {
    const cliente = clientes.find(c => c.id === garantiaSeleccionada.cliente_id);
    const fechaCreacion = garantiaSeleccionada.created_at ? new Date(garantiaSeleccionada.created_at).toLocaleDateString('es-DO') : 'N/A';
    const fechaActualizacion = garantiaSeleccionada.updated_at ? new Date(garantiaSeleccionada.updated_at).toLocaleDateString('es-DO') : 'N/A';

    return (
      <div className="garantias-container">
        <div className="garantias-header">
          <h1>👁️ Detalles de la Garantía</h1>
          <div className="header-actions">
            <button onClick={() => { setVista('lista'); setGarantiaSeleccionada(null); }} className="btn-secondary">
              ← Volver a la Lista
            </button>
            <button onClick={() => handleEditar(garantiaSeleccionada)} className="btn-primary">
              ✏️ Editar
            </button>
          </div>
        </div>

        <div className="detalles-container">
          {/* Información del Cliente */}
          <div className="detalles-section">
            <h2>👤 Información del Cliente</h2>
            <div className="detalles-grid">
              <div className="detalle-item">
                <span className="detalle-label">Nombre Completo:</span>
                <span className="detalle-valor">{cliente ? `${cliente.nombres} ${cliente.apellidos}` : 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Cédula:</span>
                <span className="detalle-valor">{cliente?.cedula || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Teléfono:</span>
                <span className="detalle-valor">{cliente?.telefono || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Dirección:</span>
                <span className="detalle-valor">{cliente?.direccion || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Información de la Garantía */}
          <div className="detalles-section">
            <h2>📦 Información de la Garantía</h2>
            <div className="detalles-grid">
              <div className="detalle-item">
                <span className="detalle-label">Número de Garantía:</span>
                <span className="detalle-valor destacado">#{garantiaSeleccionada.numero || garantiaSeleccionada.id}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Categoría:</span>
                <span className="detalle-valor">{garantiaSeleccionada.categoria || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Tipo de Producto:</span>
                <span className="detalle-valor">{garantiaSeleccionada.producto_tipo || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Estado:</span>
                <span className={`badge badge-${garantiaSeleccionada.estado?.toLowerCase() || 'default'}`}>
                  {garantiaSeleccionada.estado || 'N/A'}
                </span>
              </div>
            </div>
          </div>

          {/* Detalles del Producto */}
          <div className="detalles-section">
            <h2>🔧 Detalles del Producto</h2>
            <div className="detalles-grid">
              <div className="detalle-item">
                <span className="detalle-label">Marca:</span>
                <span className="detalle-valor">{garantiaSeleccionada.marca || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Modelo:</span>
                <span className="detalle-valor">{garantiaSeleccionada.modelo || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Color:</span>
                <span className="detalle-valor">{garantiaSeleccionada.color || 'N/A'}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Valor Estimado:</span>
                <span className="detalle-valor destacado-grande">${garantiaSeleccionada.valor_estimado?.toFixed(2) || '0.00'}</span>
              </div>
            </div>
          </div>

          {/* Descripción */}
          {garantiaSeleccionada.descripcion && (
            <div className="detalles-section">
              <h2>📝 Descripción</h2>
              <div className="descripcion-box">
                {garantiaSeleccionada.descripcion}
              </div>
            </div>
          )}

          {/* Información Adicional */}
          <div className="detalles-section">
            <h2>ℹ️ Información Adicional</h2>
            <div className="detalles-grid">
              <div className="detalle-item">
                <span className="detalle-label">Fecha de Registro:</span>
                <span className="detalle-valor">{fechaCreacion}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Última Actualización:</span>
                <span className="detalle-valor">{fechaActualizacion}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">ID de Garantía:</span>
                <span className="detalle-valor">#{garantiaSeleccionada.id}</span>
              </div>
              <div className="detalle-item">
                <span className="detalle-label">Estado de Vinculación:</span>
                <span className={`badge ${garantiaSeleccionada.prestamo_id ? 'badge-vinculada' : 'badge-disponible'}`}>
                  {garantiaSeleccionada.prestamo_id ? '🔗 Vinculada' : '✅ Disponible'}
                </span>
              </div>
            </div>
          </div>

          {/* Acciones rápidas */}
          <div className="detalles-acciones">
            <button onClick={() => handleEditar(garantiaSeleccionada)} className="btn-primary">
              ✏️ Editar Garantía
            </button>
            <button onClick={() => abrirVincular(garantiaSeleccionada)} className="btn-secondary">
              🔗 Vincular a Préstamo
            </button>
            <button
              onClick={() => {
                setVista('eliminar');
              }}
              className="btn-danger"
            >
              🗑️ Eliminar Garantía
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default Garantias;